import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
  const { title, description, keywords } = seoMetaData.webDevelopment;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href="https://www.cloudkode.com/services/web-development" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What technology do you use for web development?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We use a variety of technologies including React, Angular, Node.js, and PHP, depending on the project requirements."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can you develop e-commerce website?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we specialize in building secure and scalable e-commerce platforms that provide a seamless shopping experience."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How do you ensure website security?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We implement best practices such as HTTPS, regular security audits, and secure coding techniques to protect your website from vulnerabilities."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer SEO services as part of web development?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we integrate SEO best practices into our web development process to help improve your website’s visibility on search engines."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can you redesign my existing website?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! We can revamp your existing website to improve its design, functionality, and user experience."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is the typical timeline for a web development project?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The timeline varies based on the project scope, but most web development projects take between 4 to 12 weeks to complete."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you provide ongoing support after the website is launched?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer ongoing support and maintenance services to ensure your website remains up-to-date and functional."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can you integrate third-party services into my website?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we can integrate various third-party services such as payment gateways, CRM systems, and social media platforms to enhance your website’s functionality."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is responsive web design?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Responsive web design ensures that your website looks and functions well on all devices, including desktops, tablets, and smartphones."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you provide content management systems (CMS)?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we can implement CMS solutions like WordPress, Drupal, or custom-built systems to allow you to easily manage your website content."
                  }
                }
              ]
            }
          `}
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.webDevelopment} /> 
   <About data={aboutData.webdevlopment} />
   <Whyus data={whyusData.webdevlopment}/>
   <Contact data={contactData.webdevlopment}/>
   <Faq data={faqData.webdevlopment}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
